export default __webpack_public_path__ + "static/media/ic_polygon_16.5cb70e5d.svg";